import { TForm } from '@/components/forms/form-service-division/ServiceDivisionForm.types';
import useDeleteServiceDivision from '@/hooks/queries/service-division-api/useDeleteServiceDivision';
import useGetServiceDivisionById from '@/hooks/queries/service-division-api/useGetServiceDivisionById';
import usePatchServiceDivision from '@/hooks/queries/service-division-api/usePatchServiceDivision';
import useGetServiceById from '@/hooks/queries/services-api/useGetServiceById';
import { getChangedValues } from '@/utils/forms';
import { useParams } from 'react-router-dom';

const useEditServiceDivision = () => {
  const { divisionId, id: serviceId } = useParams();
  const {
    data: serviceDivision,
    isError: isErrorServiceDivision,
    isLoading: isLoadingServiceDivision
  } = useGetServiceDivisionById(divisionId);
  const {
    data: service,
    isError: isErrorService,
    isLoading: isLoadingService
  } = useGetServiceById(serviceId);
  const { mutate, isPending } = usePatchServiceDivision();
  const { mutate: deleteServiceDivision, isPending: isPendingDelete } =
    useDeleteServiceDivision();

  const { name, description, quantity, duration, id } = serviceDivision ?? {};

  const isError = isErrorServiceDivision || isErrorService;
  const isLoading = isLoadingServiceDivision || isLoadingService;

  const defaultValues = {
    name,
    description: description ?? undefined,
    quantity,
    duration
  };

  const onSubmit = (data: TForm) => {
    const onlyChangedData = getChangedValues<Partial<any>>(defaultValues, data);
    mutate({
      payload: { ...onlyChangedData, service: service?.id },
      divisionId: serviceDivision?.id ?? ''
    });
  };

  return {
    serviceDivision,
    isError,
    isLoading,
    service,
    isPending,
    deleteServiceDivision,
    isPendingDelete,
    onSubmit,
    name,
    description,
    quantity,
    duration,
    id,
    defaultValues
  };
};

export default useEditServiceDivision;
